import Hotel from './Hotel'
export default class Location {
    constructor(data = {}) {
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.isActive = data.isActive || false;
        this.isDomestic = data.isDomestic || true;
        this.order = data.order || 1;
        this.id = data.id || undefined;
        this.image = data.image || undefined;
        this.setHotels(data.hotels);
    }

    setHotels(hotels=[]){
        return hotels.map(h => new Hotel(h));
    }
}
